import React, { useEffect } from "react";
import styled from "styled-components";
import ArrowDownIcon from "../../../../assets/icons/ArrowDownIcon";
import { Dropdown, notification } from "antd";
import { useApiHook } from "@bjsdistribution/tms-component-library";
import { useNavigate } from "react-router-dom";
import LogoutIcon from "../../../../assets/icons/LogoutIcon";
const SuperAdmin = ({ userInfo }: any) => {
  console.log("profileWrap", userInfo);
  const navigate = useNavigate();
  const items = [
    {
      key: "1",
      label: (
        <div onClick={() => logOutTMs()} style={{ display: "flex", alignItems: "center", padding: "10px 20px", gap: "8px" }}>
          <LogoutIcon />
          <a
            href="javascript:void(0)"
            style={{
              display: "flex",
              minHeight: "40px",
              alignItems: "center",
              gap: "12px",
              cursor: "pointer",
              fontFamily: "Lato",
              fontSize: "13px",
              fontStyle: "normal",
              fontWeight: 400,
              textDecoration: "none",
              color: "#8D8F90",
            }}
          >
            Logout
          </a>
        </div>
      ),
    },
  ];

  const {
    fetchData: FetchLogout,
    loading: logoutApiLoading,
    data: logoutApiResp,
  } = useApiHook<{
    data: any;
  }>({
    endpoint: "begin_login/logout",
    method: "POST",
    body: {},
  });

  const logOutTMs = () => {
    FetchLogout();
  };

  useEffect(() => {
    //@ts-ignore
    if (logoutApiResp?.code === 200) {
      localStorage.clear();

      notification.success({
        message: "Success",
        //@ts-ignore
        description: logoutApiResp?.message,
      });

      navigate("/login");
    }
  }, [logoutApiLoading]);

  return (
    <SuperAdminWrapper>
      <div className="role">
        <strong>{`${userInfo?.username}`.trim()}</strong>
      </div>

      <Dropdown menu={{ items }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            gap: "8px",
          }}
        >
          <div className="profileWrap">
            <img src="/assets/images/user.png" alt="User Profile" />
          </div>
          <div className="toggleIcon">
            <ArrowDownIcon />
          </div>
        </div>
      </Dropdown>
    </SuperAdminWrapper>
  );
};

export default SuperAdmin;

const SuperAdminWrapper = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;

  .profileWrap {
    padding-right: 4px;
    width: 41px;
    height: 41px;
    overflow: hidden;
    border-radius: 10px;
    cursor: pointer;
  }
  .role {
    strong,
    span {
      display: block;
      font-style: normal;
    }
    strong {
      color: ${({ theme }: any) => theme.primaryBlue};
      font-size: 14px;
      font-weight: 500;
      line-height: 24px;
    }
    span {
      color: ${({ theme }: any) => theme.lightGray};
      font-size: 13px;
      font-weight: 400;
      line-height: 16px;
    }
  }
  .toggleIcon {
    padding-top: 7px;
  }
`;
